module.exports = __webpack_public_path__ + "static/media/superyachttimes.974238a8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/superyachttimes.webp
// module id = 592
// module chunks = 0